import { type Context, createContext } from 'react';

import { type ExperienceTrackerAPI } from '../ExperienceTracker';

export const ExperienceTrackerContext: Context<ExperienceTrackerAPI> =
	createContext<ExperienceTrackerAPI>({
		abort() {},
		fail() {},
		start() {},
		succeed() {},
		stopOnError() {},
		subscribe() {
			return () => {};
		},
	});
